"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpan = exports.StyledLabel = exports.StyledAsterisk = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactstrap = require("reactstrap");
var _templateObject, _templateObject2, _templateObject3;
var StyledAsterisk = exports.StyledAsterisk = (0, _styledComponents["default"])(_reactFontawesome.FontAwesomeIcon)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 5px;\n  vertical-align: super;\n"])));
var StyledLabel = exports.StyledLabel = (0, _styledComponents["default"])(_reactstrap.Label)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 12px;\n"])));
var StyledSpan = exports.StyledSpan = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 12px;\n"])));